import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Stack from "@mui/material/Stack"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"

import type { LiveChatWidgetCdnObject } from "@models/live_chat_widget"
import { formatDate } from "@utils/functions/formatDate"
import { formatBytes } from "@utils/functions/format_bytes"

export default function LiveFilesTable({
  translate,
  files,
  totalBytes
}: {
  translate: (key: string) => string
  files: LiveChatWidgetCdnObject[]
  totalBytes?: number | null
}) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack gap={1.5}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="baseline"
            flexWrap="wrap"
          >
            <Typography variant="subtitle1">
              {translate("live_chat_widget_live_files_title")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {files.length} · {formatBytes(totalBytes)}
            </Typography>
          </Stack>

          {files.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              {translate("live_chat_widget_live_files_empty")}
            </Typography>
          )}

          {files.length > 0 && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{translate("live_chat_widget_key")}</TableCell>
                  <TableCell align="right">
                    {translate("live_chat_widget_size")}
                  </TableCell>
                  <TableCell align="right">
                    {translate("live_chat_widget_last_modified")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {files.map((file) => (
                  <TableRow key={file.key}>
                    <TableCell sx={{ fontFamily: "monospace" }}>
                      {file.key}
                    </TableCell>
                    <TableCell align="right">
                      {formatBytes(file.size)}
                    </TableCell>
                    <TableCell align="right">
                      {file.lastModified
                        ? formatDate("tr-TR", file.lastModified)
                        : "—"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
